// extracted by mini-css-extract-plugin
export default {"videoCTA":"videoCTA__TQhAc","videoCta":"videoCTA__TQhAc"};